module.exports = __webpack_public_path__ + "static/media/Brochure_Template.68ee4e7b.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateProductWizard/images/Brochure_Template.JPG
// module id = 1073
// module chunks = 0